<template>
  <div class="project-thumbnail" :class="(position, index > 0 ? 'bottom' : '')">
    <svg
      v-if="image === 'P_RE_thumbnail.svg'"
      viewBox="0 0 667 667"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H667V667H0L0 0Z" fill="#FFEEE1" />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0H667V667H0L0 0Z" fill="#FFEEE1" />
      </mask>
      <g mask="url(#mask0)">
        <path
          class="clouds"
          d="M84.1023 52.9722C57.1229 58.3773 55.8739 83.7514 58.6218 95.7628C25.6471 90.3577 15.9044 113.029 15.1549 125.04C13.3667 153.698 43.883 168.081 58.6218 170.083C107.784 179.092 165.54 175.338 188.273 172.335C232.48 166.496 245.229 145.059 245.229 132.548C245.229 107.154 220.998 101.518 207.758 102.519C210.156 68.2867 183.776 56.7257 170.286 55.2243C149.302 52.2214 135.563 67.4859 131.316 75.4936C115.728 52.6719 93.3452 50.9703 84.1023 52.9722Z"
          fill="#FBE5D4"
        />
        <path
          class="clouds"
          d="M518.848 314.236C471.873 323.66 469.699 367.901 474.483 388.843C417.069 379.419 400.106 418.948 398.801 439.89C395.687 489.854 448.821 514.933 474.483 518.423C560.082 534.13 660.643 527.585 700.224 522.35C777.195 512.168 799.394 474.793 799.394 452.979C799.394 408.703 757.203 398.878 734.151 400.623C738.326 340.938 692.395 320.781 668.907 318.163C632.371 312.927 608.449 339.542 601.055 353.503C573.913 313.713 534.942 310.746 518.848 314.236Z"
          fill="#FBE5D4"
        />
        <path
          class="clouds"
          d="M51.4438 334.771C90.2427 325.301 111.427 346.934 112.933 364.367C117.344 415.426 42.2059 442.442 3.81114 446.388C-93.1862 461.947 -160.738 426.376 -182.389 406.646C-228.116 363.352 -217.674 321.51 -201.442 306.021C-174.372 280.191 -143.128 293.901 -133.024 306.021C-129.56 259.345 -100.758 239.933 -81.0615 237.529C-42.2626 232.794 -26.7892 261.487 -23.9024 276.426C6.58251 253.426 34.9889 262.897 45.3814 270.507C72.4021 288.771 60.6816 320.96 51.4438 334.771Z"
          fill="#FBE5D4"
        />
      </g>
      <path
        class="heart"
        d="M218.998 173.184C150.504 188.414 107.119 254.316 128.674 323.123C159.685 422.118 239.465 468.515 277.504 492.574C330.492 526.09 359.611 517.866 399.647 492.574C501.32 428.345 536.765 342.301 542.319 304.638C551.556 241.992 512.966 207.349 501.241 197.771C452.121 157.652 375.013 164.969 336.009 205.021C290.847 165.996 246.711 167.023 218.998 173.184Z"
        fill="#FFCDB1"
      />
      <path
        class="heart2"
        d="M259.425 210.746C180.278 210.746 146.147 270.987 167.868 324.128C197.741 397.209 261.948 438.051 291.201 456.658L291.752 457.009C332.135 482.699 356.365 471.808 386.877 452.421C464.364 403.188 496.458 344.222 502.642 315.711C513.628 265.064 482.54 234.03 468.086 225.095C416.692 193.322 354.05 220.194 335.489 253.793C313.957 225.519 286.15 210.746 259.425 210.746Z"
        fill="#FE755E"
      />
      <path
        class="arms__right"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M533.674 353.145C535.605 352.569 536.993 350.757 536.943 348.644C536.884 346.113 534.783 344.109 532.252 344.169C531.368 344.19 530.548 344.46 529.858 344.91C528.087 345.533 526.483 346.166 524.965 346.764C520.49 348.528 516.771 349.994 511.763 350.058C505.483 350.137 497.226 348.037 491.968 346.7C490.383 346.297 489.071 345.963 488.168 345.779C470.292 342.141 458.065 342.693 454.908 355.279C451.943 371.63 463.187 377.067 470.017 378.305C499.017 383.125 538.13 378.784 545.789 377.582C545.791 377.582 545.792 377.582 545.793 377.582C548.324 377.523 550.328 375.422 550.268 372.891C550.226 371.108 549.172 369.587 547.667 368.864C548.056 368.961 548.465 369.008 548.885 368.998C551.416 368.939 553.42 366.838 553.36 364.307C553.301 361.776 551.2 359.773 548.669 359.832C548.361 359.839 548.061 359.877 547.771 359.942C549.427 359.219 550.566 357.548 550.521 355.631C550.462 353.099 548.362 351.096 545.83 351.155C545.268 351.169 544.732 351.282 544.239 351.479L533.674 353.145ZM532.468 353.335C532.468 353.335 532.468 353.335 532.468 353.335Z"
        fill="#FE755E"
      />
      <path
        class="arms__left"
        d="M130.85 352.145C128.914 351.589 127.508 349.793 127.534 347.681C127.565 345.15 129.642 343.123 132.174 343.154C133.058 343.165 133.88 343.425 134.575 343.867C136.353 344.471 137.964 345.085 139.488 345.666C143.983 347.38 147.719 348.805 152.727 348.812C159.007 348.821 167.24 346.628 172.483 345.232C174.063 344.812 175.371 344.463 176.273 344.269C194.107 340.43 206.338 340.846 209.637 353.395C212.785 369.713 201.602 375.275 194.787 376.589C165.845 381.734 126.689 377.833 119.013 376.716L119.009 376.716C116.478 376.685 114.451 374.608 114.482 372.076C114.504 370.293 115.541 368.76 117.037 368.02C116.648 368.122 116.24 368.174 115.819 368.168C113.287 368.137 111.26 366.06 111.291 363.528C111.323 360.997 113.4 358.969 115.932 359.001C116.24 359.004 116.542 359.039 116.833 359.1C115.168 358.396 114.01 356.739 114.034 354.82C114.065 352.289 116.142 350.261 118.674 350.293C119.234 350.299 119.77 350.407 120.264 350.597L130.85 352.145Z"
        fill="#FE755E"
      />
      <path
        class="mouse"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M251.8 310.844C253.778 309.784 256.241 310.528 257.302 312.506C270.165 336.499 299.905 353.742 335.058 353.742C370.212 353.742 399.951 336.499 412.815 312.506C413.876 310.528 416.339 309.784 418.317 310.844C420.295 311.905 421.038 314.368 419.978 316.346C405.461 343.423 372.667 361.87 335.058 361.87C297.45 361.87 264.656 343.423 250.139 316.346C249.078 314.368 249.822 311.905 251.8 310.844Z"
        fill="#AC4323"
      />
      <path
        class="eyes"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M282.336 301.555C280.126 301.16 278.656 299.049 279.051 296.84C279.625 293.626 280.894 288.994 283.827 285.082C286.897 280.986 291.707 277.826 298.716 277.826C305.715 277.826 310.563 280.977 313.656 285.069C316.62 288.989 317.9 293.639 318.399 296.948C318.734 299.167 317.207 301.238 314.988 301.573C312.769 301.908 310.698 300.381 310.363 298.162C309.976 295.596 309.021 292.414 307.173 289.97C305.455 287.698 302.914 285.953 298.716 285.953C294.529 285.953 292.03 287.688 290.33 289.957C288.492 292.408 287.527 295.609 287.051 298.27C286.656 300.479 284.545 301.95 282.336 301.555Z"
        fill="#AC4323"
      />
      <path
        class="eyes"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M355.02 301.555C352.811 301.16 351.34 299.049 351.735 296.84C352.31 293.626 353.579 288.994 356.512 285.082C359.582 280.986 364.391 277.826 371.401 277.826C378.4 277.826 383.247 280.977 386.341 285.069C389.305 288.989 390.584 293.639 391.084 296.948C391.419 299.167 389.892 301.238 387.673 301.573C385.453 301.908 383.383 300.381 383.048 298.162C382.66 295.596 381.705 292.414 379.858 289.97C378.14 287.698 375.598 285.953 371.401 285.953C367.213 285.953 364.715 287.688 363.015 289.957C361.177 292.408 360.211 295.609 359.736 298.27C359.341 300.479 357.229 301.95 355.02 301.555Z"
        fill="#AC4323"
      />
      <path
        class="light"
        d="M335.428 110.653H331.549C329.125 110.653 327.239 112.763 327.512 115.173L332.479 159.173C332.615 160.376 334.362 160.376 334.498 159.173L339.466 115.173C339.738 112.763 337.853 110.653 335.428 110.653Z"
        fill="#FFCDB1"
      />
      <path
        class="light"
        d="M331.627 581.463H335.354C337.805 581.463 339.699 579.308 339.384 576.877L334.498 539.188C334.345 538.008 332.636 538.008 332.483 539.188L327.598 576.877C327.282 579.308 329.176 581.463 331.627 581.463Z"
        fill="#FFCDB1"
      />
      <path
        class="light"
        d="M597.624 337.704L597.624 334.023C597.624 331.564 595.456 329.668 593.018 329.996L556.91 334.857C555.736 335.015 555.736 336.712 556.91 336.87L593.018 341.731C595.456 342.059 597.624 340.163 597.624 337.704Z"
        fill="#FFCDB1"
      />
      <path
        class="light"
        d="M69.3545 334.047L69.3545 337.678C69.3545 340.146 71.537 342.044 73.9815 341.702L108.508 336.869C109.674 336.705 109.674 335.02 108.508 334.856L73.9815 330.023C71.537 329.68 69.3545 331.579 69.3545 334.047Z"
        fill="#FFCDB1"
      />
      <path
        class="light"
        d="M504.396 511.347L507.169 508.57C508.877 506.86 508.724 504.047 506.841 502.532L470.537 473.331C469.589 472.568 468.346 473.813 469.11 474.76L498.357 511.026C499.874 512.907 502.688 513.057 504.396 511.347Z"
        fill="#FFCDB1"
      />
      <path
        class="light"
        d="M133.843 133.569L131.186 136.23C129.458 137.96 129.639 140.814 131.572 142.313L162.583 166.354C163.527 167.086 164.741 165.871 164.008 164.927L139.927 133.947C138.426 132.016 135.572 131.839 133.843 133.569Z"
        fill="#FFCDB1"
      />
      <path
        class="light"
        d="M561.325 433.187L562.809 429.61C563.738 427.369 562.509 424.818 560.178 424.148L517.883 411.984C516.721 411.65 516.052 413.263 517.11 413.849L555.601 435.185C557.723 436.361 560.396 435.428 561.325 433.187Z"
        fill="#FFCDB1"
      />
      <path
        class="light"
        d="M72.5529 227.993L71.1256 231.435C70.1865 233.7 71.4516 236.274 73.8183 236.914L110.504 246.837C111.653 247.148 112.308 245.57 111.276 244.976L78.3327 226.027C76.2076 224.805 73.492 225.728 72.5529 227.993Z"
        fill="#FFCDB1"
      />
      <path
        class="light"
        d="M420.757 552.911L423.998 551.544C426.29 550.576 427.182 547.795 425.881 545.674L409.29 518.641C408.681 517.649 407.153 518.294 407.439 519.422L415.238 550.167C415.85 552.578 418.465 553.879 420.757 552.911Z"
        fill="#FFCDB1"
      />
      <path
        class="light"
        d="M230.189 87.2039L226.434 88.7887C224.233 89.718 223.305 92.337 224.43 94.4453L250.797 143.866C251.38 144.958 253.037 144.258 252.662 143.079L235.641 89.7128C234.915 87.4363 232.39 86.2746 230.189 87.2039Z"
        fill="#FFCDB1"
      />
      <path
        class="light"
        d="M242.173 549.463L245.497 550.847C247.78 551.798 250.376 550.505 250.994 548.11L259.472 515.209C259.765 514.072 258.216 513.427 257.616 514.436L240.242 543.634C238.977 545.759 239.889 548.513 242.173 549.463Z"
        fill="#FFCDB1"
      />
      <path
        class="light"
        d="M432.891 90.8493L429.177 89.3031C426.962 88.3811 424.435 89.5684 423.73 91.8617L408.362 141.904C408.001 143.08 409.649 143.766 410.229 142.681L434.912 96.5168C436.044 94.4012 435.105 91.7713 432.891 90.8493Z"
        fill="#FFCDB1"
      />
      <path
        class="light"
        d="M157.797 509.087L160.64 511.915C162.343 513.608 165.135 513.463 166.654 511.603L199.225 471.707C200.001 470.756 198.738 469.5 197.791 470.282L158.075 503.072C156.224 504.601 156.094 507.394 157.797 509.087Z"
        fill="#FFCDB1"
      />
      <path
        class="light"
        d="M533.413 138.463L530.859 135.924C529.106 134.18 526.214 134.393 524.736 136.377L504.419 163.638C503.717 164.579 504.908 165.763 505.845 165.056L532.994 144.589C534.969 143.101 535.167 140.207 533.413 138.463Z"
        fill="#FFCDB1"
      />
      <path
        class="light"
        d="M104.517 429.251L106.065 432.837C107.025 435.059 109.701 435.955 111.805 434.759L151.485 412.194C152.541 411.594 151.845 409.983 150.685 410.34L107.053 423.756C104.74 424.467 103.557 427.029 104.517 429.251Z"
        fill="#FFCDB1"
      />
      <path
        class="light"
        d="M594.979 225.827L593.502 222.406C592.53 220.155 589.801 219.271 587.694 220.525L555.031 239.953C554.008 240.561 554.686 242.13 555.83 241.802L592.367 231.345C594.724 230.67 595.951 228.078 594.979 225.827Z"
        fill="#FFCDB1"
      />
    </svg>
    <img v-else :src="`images/thumbnail/${image}`" />
    <h2>{{ title }}</h2>
    <span>{{ role }}<br />{{ year }}</span>
  </div>
</template>

<script>
export default {
  name: "ProjectThumb",
  props: {
    index: { type: [String, Number], default: "" },
    image: { type: String, default: "left" },
    position: { type: String, default: "left" },
    role: { type: String, default: "left" },
    title: { type: String, default: "left" },
    year: { type: String, default: "left" },
  },
  created() {},
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.project-thumbnail.bottom {
  margin-top: 100px;
}
.project-thumbnail.left {
  margin-left: 10%;
}
.project-thumbnail.right {
  margin-right: 10%;
}
.project-thumbnail {
  cursor: pointer;
  width: 70%;
  color: #303133;
  img {
    width: 100%;
  }

  h2 {
    font-size: 28px;
    margin-top: 30px;
    margin-bottom: 10px;
  }

  span {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 0;
    color: grey;
    opacity: 0.7;
  }
}

.heart {
  animation-name: adjustScale;
  transform: scale(1);
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  transform-box: fill-box;
  transform-origin: center;
}

@keyframes adjustScale {
  to {
    transform: scale(1.05);
  }
}

.heart2 {
  animation-name: adjustScale2;
  transform: scale(1.05);
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  transform-box: fill-box;
  transform-origin: center;
}

@keyframes adjustScale2 {
  to {
    transform: scale(1);
  }
}

.arms__right {
  animation-name: shake_right;
  animation-duration: 0.7s;
  animation-fill-mode: both;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  transform-box: fill-box;
  transform-origin: center;
}

@keyframes shake_right {
  from {
    transform: skewY(2deg);
  }
  to {
    transform: skewY(-2deg);
  }
}

.arms__left {
  animation-name: shake_left;
  animation-duration: 0.7s;
  animation-fill-mode: both;
  animation-direction: alternate;
  animation-iteration-count: infinite;
}

@keyframes shake_left {
  from {
    transform: skewY(1deg);
  }
  to {
    transform: skewY(-1deg);
  }
}

.light {
  animation-name: adjustLight;
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  transform-box: fill-box;
  transform-origin: center;
}

@keyframes adjustLight {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.2);
  }
}

.mouse {
  animation-name: smile;
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-direction: alternate;
  animation-iteration-count: infinite;
}

.eyes {
  animation-name: smile;
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-direction: alternate;
  animation-iteration-count: infinite;
}

@keyframes smile {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-10px);
  }
}

.clouds {
  animation-name: cloude_move;
  animation-duration: 20s;
  animation-fill-mode: both;
  animation-direction: normal;
  animation-iteration-count: infinite;
}

@keyframes cloude_move {
  from {
    transform: translateX(150%);
  }
  to {
    transform: translateX(-150%);
  }
}

@media (min-width: 320px) and (max-width: 480px) {
  .project-thumbnail {
    h2 {
      font-size: 15px;
      margin-top: 10px;
      margin-bottom: 5px;
    }

    span {
      font-size: 12px;
      line-height: 12px;
    }
  }
}
</style>
